import { render, staticRenderFns } from "./AddedKicksMotions.vue?vue&type=template&id=790b0c66&"
import script from "./AddedKicksMotions.vue?vue&type=script&lang=js&"
export * from "./AddedKicksMotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports